<template>
  <div :class="[
         'scrollable',
         $style.scrollable
       ]"
       @scroll="$emit('scroll', $event)"
  >
    <slot/>
  </div>
</template>

<script>
/*
 *
 * b-scrollable component
 *
 */
export default {
  name: 'b-scrollable',
}
</script>

<style lang="scss" module>
.scrollable {
  overflow: auto;
}
</style>
